import React, { useState } from "react";
import { X, Send, Loader2 } from "lucide-react";
import { sendMail } from "../../../api";
import { useToast } from "../../../hooks/use-toast";
import { inputCls } from "./mailUtils";

const MailCompose = ({ initial, onClose, onSent }) => {
  const [form, setForm] = useState({ to: "", subject: "", body: "", account: "prospecting", reply_to_id: "", ...initial });
  const [sending, setSending] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await sendMail(form);
      toast({ title: "Email envoyé ✓", description: `À ${form.to}` });
      onSent?.();
      onClose();
    } catch (err) {
      toast({ title: "Échec de l'envoi", description: err?.response?.data?.detail || "Erreur SMTP", variant: "destructive" });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" data-testid="mail-compose-modal">
      <form onSubmit={submit} className="bg-white rounded-xl w-full max-w-2xl shadow-xl">
        <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-200">
          <h3 className="font-heading font-bold text-neutral-900">{form.reply_to_id ? "Répondre" : "Nouveau message"}</h3>
          <button type="button" onClick={onClose} className="text-neutral-400 hover:text-neutral-700" data-testid="mail-compose-close"><X size={18} /></button>
        </div>
        <div className="p-5 space-y-3">
          <div className="grid sm:grid-cols-[1fr_200px] gap-3">
            <input required type="email" placeholder="Destinataire" className={inputCls} value={form.to} data-testid="mail-compose-to"
              onChange={(e) => setForm({ ...form, to: e.target.value })} />
            <select className={inputCls} value={form.account} data-testid="mail-compose-account" onChange={(e) => setForm({ ...form, account: e.target.value })}>
              <option value="prospecting">Depuis prospect@</option>
              <option value="notification">Depuis contact@</option>
            </select>
          </div>
          <input required placeholder="Objet" className={inputCls} value={form.subject} data-testid="mail-compose-subject"
            onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          <textarea required rows={10} placeholder="Votre message…" className={inputCls} value={form.body} data-testid="mail-compose-body"
            onChange={(e) => setForm({ ...form, body: e.target.value })} />
        </div>
        <div className="flex justify-end gap-3 px-5 py-3 border-t border-neutral-200">
          <button type="button" onClick={onClose} className="text-sm text-neutral-600 hover:text-neutral-900 px-3">Annuler</button>
          <button type="submit" disabled={sending} data-testid="mail-compose-send"
            className="flex items-center gap-2 bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-5 py-2 rounded-md disabled:opacity-60">
            {sending ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Envoyer
          </button>
        </div>
      </form>
    </div>
  );
};

export default MailCompose;
